import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        suppliers: [],
        saving: false,
        saveError: "",
        products: {
            showEditDialog: false,
            loading: false,
            loadError: "",
            supplierProducts: [],
            saving: false,
            saveError: ""
        }
    },
  
    getters: {
        supplierProducts(state, getters) {
            return state.products.supplierProducts;
        },
        supplierProductsByCategory(state, getters) {
            return state.products.supplierProducts.filter(p => p.CategoryID);
        },
        supplierProductsByIndividual(state, getters) {
            return state.products.supplierProducts.filter(p => !p.CategoryID);
        }
    },
  
    mutations: {
        setSuppliers(state, data) {
            state.suppliers = data.sort((a, b) => {
                if(a.Name > b.Name) {
                    return 1
                } else if (a.Name < b.Name) {
                    return -1
                } else {
                    return 0
                }
            });
        },
        setSupplierProducts(state, data) {
            state.products.supplierProducts = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.suppliers = [];
            state.loadError = err;
        },
        loadingProducts(state) {
            state.products.loading = true;
            state.products.loadError = "";
        },
        loadProductsComplete(state) {
            state.products.loading = false;
        },
        loadProductsError(state, err) {
            state.products.suppliers = [];
            state.products.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        },
        savingProducts(state) {
            state.products.saving = true;
            state.products.saveError = "";
        },
        saveProductsComplete(state) {
            state.products.saving = false;
        },
        saveProductsError(state, err) {
            state.products.saveError = err;
        },
        clearSaveProductsError(state) {
            state.products.saveError = "";
        },
        showProductsEditDialog(state, show) {
            state.products.showEditDialog = show;
        },
        addSupplierProduct(state, supplierProduct) {
            state.products.supplierProducts.push(supplierProduct);
        },
        removeSupplierProduct(state, removeProduct) {
            if (removeProduct.CategoryID) {
                state.products.supplierProducts = state.products.supplierProducts.filter(sp => (!sp.CategoryID) || sp.CategoryID !== removeProduct.CategoryID);
            }
            else if (removeProduct.ProductID) {
                state.products.supplierProducts = state.products.supplierProducts.filter(sp => (!sp.ProductID) || sp.ProductID !== removeProduct.ProductID);
            }
        }
    },
  
    actions: {
        addSupplierProduct(context, supplierProduct) {
            context.commit("addSupplierProduct", supplierProduct);
        },
        removeSupplierProduct(context, supplierProduct) {
            context.commit("removeSupplierProduct", supplierProduct);
        },
        showProductsEditDialog(context, options) {
            context.commit("showProductsEditDialog", options.show);
        },
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        clearSaveProductsError(context) {
            context.commit("clearSaveProductsError");
        },
        saveSupplierProducts(context, options) {
            context.commit("savingProducts");

            api.saveSupplierProducts(
                options.supplierID,
                options.supplierProducts,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        context.commit("setSupplierProducts", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveProductsError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveProductsComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveSupplier(context, options) {
            context.commit("saving");

            api.saveSupplier(
                options.supplier,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        context.commit("setSuppliers", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadSupplierProductsForStore(context, options) {
            context.commit("loadingProducts");

            api.fetchSupplierProductsForStore({
                id: options.storeID,
                success: function(response) {
                    context.commit("setSupplierProducts", response.data);

                    if (options.success) {
                        options.success(response);
                    }
                },
                error: function(e) {
                    context.commit("loadProductsError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadProductsComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
        loadSupplierProducts(context, options) {
            context.commit("loadingProducts");

            api.fetchSupplierProducts({
                id: options.id,
                success: function(response) {
                    context.commit("setSupplierProducts", response.data);
                },
                error: function(e) {
                    context.commit("loadProductsError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadProductsComplete");
                }
            });
        },
        loadSuppliers(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchSuppliers({
                    success: function(response) {
                        context.commit("setSuppliers", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        },
        loadSuppliersByStore(context, options) {
            return new Promise((resolve, reject) => {
                context.commit("loading");
                api.fetchSuppliersByStore({
                    storeID: options.storeID,
                    success: function(response) {
                        context.commit("setSuppliers", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        },
        loadSuppliersAll(context, options) {
            return new Promise((resolve, reject) => {
                context.commit("loading");
                
                api.fetchSuppliersAll({
                    allSuppliers: options.allSuppliers,
                    success: function(response) {
                        context.commit("setSuppliers", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        }
    }
}
